import { sessionService } from '../../services/session';

const authenticationReducer = (state, action) => {
  switch (action.type) {
    case 'login':
      return sessionService.save(action.value);
    case 'logout':
      sessionService.clear();
      return null;
    default:
      return state;
  }
};

export default authenticationReducer;
